// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2lsvX","title":"styles-module__title___3RI4i","subtitle":"styles-module__subtitle___iTts7","text":"styles-module__text___2O0js"};